import ErrorState from '@zenbusiness/zui/ErrorState';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Text from '@zenbusiness/zui/Text';

import { HomeSection } from '#client/components/HomeSection';
import { useNextUp } from '#client/hooks/useNextUp';

import NextUpCard from './components/NextUpCard/NextUpCard';
import * as Styled from './NextUp.style';

function NextUp() {
  const {
    data: cards, error, loading, refetch
  } = useNextUp();

  if (loading) {
    return (
      <HomeSection
        title={(
          <Text size="xl" weight="medium" loading={loading}>Next up</Text>
        )}
      >
        <Skeleton height={300} />
      </HomeSection>
    );
  }

  if (error) {
    return <ErrorState onReload={refetch} />;
  }

  if (cards.length === 0) {
    return null;
  }

  return (
    <HomeSection
      title={(
        <Text size="xl" weight="medium" loading={loading}>Next up</Text>
      )}
    >

      <Styled.CardList component="ul">
        {cards.map((card, idx) => (
          <Styled.CardItem
            component="li"
            key={card.inAppKey}
          >
            <NextUpCard
              ctaType={card.ctaType}
              ctaUrl={card.ctaUrl}
              description={card.description}
              estimate={card.estimate}
              highlight={cards.length > 1 && idx === 0}
              imageUrl={card.image}
              instanceUuid={card.instanceUuid}
              readinessStatus={card.readinessStatus}
              title={card.title}
              tooltip={card.tooltip}
            />
          </Styled.CardItem>
        ))}
      </Styled.CardList>
    </HomeSection>
  );
}

export default NextUp;
